import React, {PureComponent} from 'react';
import toastr from "toastr";
import {Classes, Overlay} from "@blueprintjs/core";

export default class SendTestMessageModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        viberEnableRequests: '',
        testNumber: '',
        selectedNumbers: [],
        selectedNumbersIds: [],
        verifiedNumbers: this.props.verifiedNumbers
    }
    handleNumber = (number, id) => {
        let currentNumbers = [...this.state.selectedNumbers]
        let currentIds = [...this.state.selectedNumbersIds]
        let numberIndex
        //console.log('currentNumbers: ', currentNumbers)
        let newNumbers = []
        let newIds = []
        if (currentNumbers.includes(number)) {
            //console.log('array includes number')
            numberIndex = currentNumbers.indexOf(number)
            currentNumbers.splice(numberIndex, 1)
            currentIds.splice(numberIndex, 1)
            newNumbers = [...currentNumbers]
            newIds = [...currentIds]
            //console.log('newNumbers: ', newNumbers)
        } else {
            //console.log('selectedNumbers does not contain selected number')
            currentNumbers = [...currentNumbers, number]
            currentIds = [...currentIds, id]
            //console.log('currentNumbers: ', currentNumbers)
            newNumbers = [...currentNumbers]
            newIds = [...currentIds]
            //console.log('newNumbers: ', newNumbers)
        }
        this.setState({selectedNumbers: newNumbers, selectedNumbersIds: newIds})
    }

    handleClose = () => {

        this.setState({
            selectedNumbers: [],
            selectedNumbersIds: []
        })
        this.props.handleClose()
    }

    sendTestSMS = () => {
        if (this.state.selectedNumbers.length !== 0) {
            this.props.sendTestSMS(this.state.selectedNumbers, this.state.selectedNumbersIds)

        } else {
            toastr.error('You need to select at least 1 number to send test SMS.')
        }
    }
    componentDidMount = () => {
        this.setState({
            overlayIsOpen: this.props.showModal,
        })
    }

    componentDidUpdate = () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                overlayIsOpen: this.props.showModal
            })
        }
        if (this.state.verifiedNumbers !== this.props.verifiedNumbers) {
            this.setState({
                verifiedNumbers: this.props.verifiedNumbers
            })
        }
    }

    setTestNumber = (e) => {
        this.setState({testNumber: e.target.value})
    }

    render() {
        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>
                    <div className="add-payment-method-modal-container">
                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.handleClose}>
                                <i className="fas fa-times"></i>
                            </p>
                            <h2>Send Test Message</h2>
                        </div>
                        {/*{console.log('Errors List: ', this.state.errorsList)}*/}
                        <div className='modal-main'>
                            <div className='margin-top-20 margin-bottom-10'>

                            </div>

                            <p>Preview your message live and test out the service by sending it to one of your
                                verified
                                test numbers. Test message will be charged in local cost for 1 SMS.</p>
                            <div className="verified-numbers-container">
                                {this.state.verifiedNumbers ?
                                    this.state.verifiedNumbers.map(verifiedNumber => {
                                            return (
                                                <div key={verifiedNumber.phone_number}
                                                     onClick={() => this.handleNumber(verifiedNumber.phone_number, verifiedNumber.id)}
                                                     className={this.state.selectedNumbers.includes(verifiedNumber.phone_number) ? 'verified-number active' : 'verified-number'}>
                                                    <div className="number-container">{verifiedNumber.phone_number}</div>
                                                    <div className="name-container">{verifiedNumber.friendly_name}</div>
                                                </div>
                                            )
                                        }
                                    )
                                    : ''
                                }

                                {/*<div onClick={() => this.handleNumber('+1080012344444')}*/}
                                {/*     className={this.state.selectedNumbers.includes('+1080012344444') ? 'verified-number active' : 'verified-number'}>*/}
                                {/*    <div className="number-container">+1080012344444</div>*/}
                                {/*    <div className="name-container">Brad Michaels</div>*/}
                                {/*</div>*/}
                                {/*<div onClick={() => this.handleNumber('+1080012355555')}*/}
                                {/*     className={this.state.selectedNumbers.includes('+1080012355555') ? 'verified-number active' : 'verified-number'}>*/}
                                {/*    <div className="number-container">+1080012355555</div>*/}
                                {/*    <div className="name-container">Mary Cooper</div>*/}
                                {/*</div>*/}

                            </div>

                            <div className='flex-end margin-top-20 margin-bottom-20'>
                                <button
                                    className='btn-white-border margin-right-20'
                                    onClick={this.handleClose}
                                >
                                    Close
                                </button>
                                <button onClick={this.sendTestSMS} className='btn-action'>
                                    Send
                                </button>

                            </div>
                        </div>
                    </div>

                </div>
            </Overlay>
        )
    }
}